import { Component } from '@angular/core';
import { TimelineStore } from './timeline.store';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.styl']
})
export class TimelineComponent {
  constructor(private timelineStore: TimelineStore) {
  }

  get width() {
    return this.timelineStore.width;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline.component.ts